import React from "react";
import { Icon, Select } from "antd";
import { isEmpty } from "lodash";
import { addOneMonth, removeOneMonth } from "./../../../modules/presence/utils/date.utils";
import { FREQUENCY_ID, PREMIUM_STATUS } from "./../../../configs/constants";
import { fetchExpensesDisctinctClients } from "../../../modules/presence/api/api";
import moment from "moment";
import { Filter } from "../../../modules/presence/expenseReports/Accounting/components/Filter.component";
const Option = Select.Option;
const SelectMonth = ({ setRangeDate, rangeDate }) => (
  <div className="flex items-center m-5 justify-center">
    <button
      className="rounded-full h-10 w-10 flex items-center justify-center"
      style={{ outline: "none" }}
      onClick={() => {
        setRangeDate(removeOneMonth(rangeDate));
      }}
    >
      <Icon type="left" />
    </button>
    <div style={{ fontSize: 30 }}>{`${rangeDate[0].format("MMMM YYYY")}`}</div>
    {rangeDate[0].format("MMMM YYYY") !== moment().format("MMMM YYYY") && (
      <button
        className="rounded-full h-10 w-10 flex items-center justify-center"
        style={{ outline: "none" }}
        onClick={() => {
          setRangeDate(addOneMonth(rangeDate));
        }}
      >
        <Icon type="right" />
      </button>
    )}
  </div>
);
const PremiumFilters = ({
  setSelectedClient,
  selectedClient,
  handledeleteBonuses,
  setSelectedStatus,
  setSelectedUser,
  rangeDate,
  token,
  setRangeDate,
  numberToDelete,
  selectedUser,
  data
}) => {
  const getUsersList = () =>
    data && !isEmpty(data)
      ? data
          .slice()
          .sort((a, b) => {
            if (typeof a.user_email !== "string" || typeof b.user_email !== "string") return 0;
            const aName = a.user_email.split("@")[0] || "";
            const aLastName = aName.split(".")[1] || "";
            const bName = b.user_email.split("@")[0] || "";
            const bLastName = bName.split(".")[1] || "";
            return aLastName.localeCompare(bLastName);
          })
          .reduce((acc, item) => {
            if (!acc.includes(item.user_fullname)) acc.push(item.user_fullname);
            return acc;
          }, [])
      : [];

  const filters = {
    match: {
      user_fullname: selectedUser

      // $or: [
      //   {
      //     $and: [
      //       { start_date: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } } },
      //       { frequency_id: FREQUENCY_ID.MONTHLY }
      //     ]
      //   },
      //   {
      //     $and: [
      //       {
      //         start_date: {
      //           $gte: { $date: moment(rangeDate[0]).startOf("quarter") },
      //           $lte: { $date: moment(rangeDate[1]).endOf("quarter") }
      //         }
      //       },
      //       { frequency_id: FREQUENCY_ID.QUARTERLY }
      //     ]
      //   }
      // ]
    }
  };
  return (
    <div className="my-8 flex items-center">
      <div className="flex flex-col justify-center items-center">
        <SelectMonth setRangeDate={setRangeDate} rangeDate={rangeDate} />
        <span>{`(trimestre : ${moment(rangeDate[0])
          .startOf("quarter")
          .format("MMMM")} - ${moment(rangeDate[0])
          .endOf("quarter")
          .format("MMMM")})`}</span>
      </div>
      <div className="mx-2">
        <Filter
          selectedItem={selectedClient}
          fetchDistinct={fetchExpensesDisctinctClients}
          placeholder={"Dossier"}
          onChange={setSelectedClient}
          token={token}
          filters={filters}
        />
      </div>
      <div className="mx-2">
        <Select
          allowClear
          showSearch
          placeholder="Nom de l'utilisateur"
          style={{ width: 200 }}
          value={selectedUser}
          onChange={setSelectedUser}
        >
          {!isEmpty(data) &&
            getUsersList().map(status => (
              <Option key={status} value={status}>
                {status}
              </Option>
            ))}
        </Select>
      </div>
      <div className="mx-2">
        <Select allowClear placeholder="Statut" style={{ width: 200 }} onChange={setSelectedStatus}>
          {Object.values(PREMIUM_STATUS)
            .sort()
            .map(status => (
              <Option key={status} value={status}>
                <div className="capitalize">{status}</div>
              </Option>
            ))}
        </Select>
      </div>

      {numberToDelete !== -1 && (
        <div className="ml-12 flex items-center">
          <div className="text-xl">Primes sélectionnées :</div>
          <div className="font-bold text-2xl mx-6">{numberToDelete}</div>
          <div
            className={"bg-orange-500 rounded-full text-white py-3 px-10 mx-2 cursor-pointer"}
            onClick={() => handledeleteBonuses()}
          >
            Supprimer
          </div>
        </div>
      )}
    </div>
  );
};

export default PremiumFilters;



// WEBPACK FOOTER //
// src/containers/admin/premium/PremiumFilters.js